import { Play, X } from 'lucide-react';

interface EpisodePlayerToggleProps {
  expanded: boolean;
  playLabel: string;
  onToggle: () => void;
}

export default function EpisodePlayerToggle({
  expanded,
  playLabel,
  onToggle,
}: EpisodePlayerToggleProps) {
  const label = expanded ? 'Close player' : playLabel;
  const Icon = expanded ? X : Play;

  return (
    <button
      type="button"
      onClick={onToggle}
      className="mt-3 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-base-300 bg-base-200 text-base-content hover:border-primary hover:text-primary"
      aria-label={label}
      aria-expanded={expanded}
      title={label}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
